class Translations {
    constructor() {
        this.translations = {};
        this.pathList = {};
    }
    init(pathList) {
        this.pathList = pathList;
    }
    async load(language) {
        const path = this.pathList[language];
        if (!this.pathList[language])
            throw Error('Language "' + language + '" was not defined in path list.');
        const response = await fetch(path);
        if (response.status === 200) {
            const translations = await response.json();
            this.translations = translations;
        }
        else
            throw Error("Could not get translations. Server responden with status " +
                response.status +
                "!");
        return true;
    }
    get(group, key) {
        if (!this.translations[group])
            return "I18N_NOT_FOUND_" + group + ":" + key;
        if (!this.translations[group][key])
            return "I18N_NOT_FOUND_" + group + "_" + key;
        return this.translations[group][key];
    }
}
const translations = new Translations();
export default translations;
